import {
  LEARNING_STATUS,
  type LearningStatus,
} from "@/models/accidentReportPersons";
import { AccidentReportPersonsConstants as Constants } from "@/pages/AccidentReportPersons/AccidentReportPersonsConstants";

const LEARNING_STATUS_LABELS: Record<LearningStatus, string> = {
  [LEARNING_STATUS.PASSED]: Constants.LearningStatusPassed,
  [LEARNING_STATUS.OVERDUE]: Constants.LearningStatusOverdue,
  // 公開終了した研修プログラムの未合格。受講義務がないため「対象外」と表示する
  [LEARNING_STATUS.NOT_APPLICABLE]: Constants.LearningStatusNotApplicable,
  [LEARNING_STATUS.NOT_TAKEN]: Constants.LearningStatusNotTaken,
};

export const learningStatusLabel = (status: LearningStatus): string =>
  LEARNING_STATUS_LABELS[status] ?? Constants.LearningStatusNotTaken;

const LEARNING_STATUS_COLORS: Record<
  LearningStatus,
  "success" | "warning" | "error" | "default"
> = {
  [LEARNING_STATUS.PASSED]: "success",
  [LEARNING_STATUS.OVERDUE]: "error",
  [LEARNING_STATUS.NOT_TAKEN]: "warning",
  [LEARNING_STATUS.NOT_APPLICABLE]: "default",
};

export const learningStatusColor = (
  status: LearningStatus,
): "success" | "warning" | "error" | "default" =>
  LEARNING_STATUS_COLORS[status] ?? "default";
